// Do not load optional vendors on authentication, recovery or capability links.
// Checking the decoded form also covers nested redirect URLs and encoded keys.
const SENSITIVE_PARAMETER = /(?:[?#&]|^)(?:access_token|refresh_token|provider_token|provider_refresh_token|id_token|token_hash|token|code|share_token|email|phone|address|symptoms|medical_issue|latitude|longitude)=/i;
const SENSITIVE_PATH = /\/(?:auth|reset-password|password-reset|forgot-password|recovery|callback|verify|share|shared-report|report|consent|patient-form)(?:[/?#]|$)/i;

function isSensitiveUrl(value: string): boolean {
  let decoded = value;
  for (let depth = 0; depth < 5; depth += 1) {
    if (SENSITIVE_PARAMETER.test(decoded) || SENSITIVE_PATH.test(decoded)) return true;
    try {
      const next = decodeURIComponent(decoded);
      if (next === decoded) return false;
      decoded = next;
    } catch {
      // Ambiguous encoded links should not reach optional vendors.
      return true;
    }
  }
  return true;
}

export function isSensitiveAnalyticsDocument(href: string, referrer: string): boolean {
  return isSensitiveUrl(href) || isSensitiveUrl(referrer);
}

export function isCurrentAnalyticsDocumentSensitive(): boolean {
  if (typeof window === 'undefined') return false;
  return isSensitiveAnalyticsDocument(
    window.location?.href ?? '',
    typeof document === 'undefined' ? '' : document.referrer ?? '',
  );
}

/** A final SDK boundary also covers persisted referrers and nested redirects. */
export function containsSensitiveAnalyticsValue(value: unknown, depth = 0): boolean {
  if (typeof value === 'string') return isSensitiveUrl(value);
  if (value === null || typeof value !== 'object') return false;
  if (depth >= 8) return true;
  return Object.entries(value).some(([key, item]) =>
    SENSITIVE_PARAMETER.test(`${key}=`) || containsSensitiveAnalyticsValue(item, depth + 1));
}
